import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsPresenceBulletsIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M877.714 521.143q0 119.429-58.857 220.286T659.143 901.143 438.857 960t-220.286-58.857T58.857 741.429 0 521.143t58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z" />
    </g>
  </StyledIcon>
)

CsPresenceBulletsIcon.displayName = 'CsPresenceBulletsIcon'
